var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.component)?_c('Sidebar',{attrs:{"isClosable":_vm.fechavel},on:{"close":_vm.fechar}},[_c(_vm.component,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }